import React, { Component } from "react";
import Datablock from "./Datablock";

export default class AzDbs extends Component {
  constructor() {
    super();
    this.state = {
      currentDeath: undefined,
      currentPositive: undefined,
      currentTest: undefined,
      everHosp: undefined,
      deathImg: "logos/rip.png",
      positiveImg: "logos/coronavirus.png",
      testImg: "logos/covid-test.png",
      hospImg: "logos/hospital.png",
    };
  }
  //DEFAULT: fetch("https://api.covidtracking.com/v1/states/az/current.json")
  //fetch("https://shugert-api-covid-az.herokuapp.com/current")
  componentDidMount() {
    fetch("https://api.covidtracking.com/v1/states/az/current.json")
      .then((response) => response.json())
      .then((data) => {
        const currentDeath = data.death;
        const currentPositive = data.positive;
        const currentTest = data.totalTestResults;
        const everHosp = data.hospitalized;
        this.setState({
          currentDeath: currentDeath,
          currentPositive: currentPositive,
          currentTest: currentTest,
          everHosp: everHosp,
        });
      });
  }
  render() {
    const {
      currentDeath,
      currentPositive,
      currentTest,
      everHosp,
      positiveImg,
      deathImg,
      testImg,
      hospImg,
    } = this.state;
    return (
      <div className="dblockcol">
        <Datablock
          number={currentPositive}
          title={"TOTAL CASES"}
          img={positiveImg}
        />
        <Datablock number={currentTest} title={"TOTAL TESTS"} img={testImg} />
        <Datablock
          number={everHosp}
          title={"EVER HOSPITALIZED"}
          img={hospImg}
        />
        <Datablock
          number={currentDeath}
          title={"TOTAL DEATHS"}
          img={deathImg}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AzDbs.js